module.exports = __webpack_public_path__ + "img/classic_3.ced37b7d.png";